<template>
    <div class="wrap">
		<header class="header header--result">
			<div class="header__container">
				<div class="header__row">
					<div class="logo">
						<div class="logo__container">
							<div class="logo__row">
								<a href="/myprotein">
									<h1 class="logo__logo" :class="{'logo__logo logo__logo--black' : this.isPopup} " aria-label="my Protein TEST"></h1>
								</a>
								<button @click="popup()" type="button" :class="{'rotate-down' : this.isPopup}" class="logo__trigger" aria-controls="logoLayer" aria-label="버튼" aria-haspopup="true" aria-expanded="false"></button>
								<!-- 팝업 -->
								<div :style=" {display : this.isPopup? 'block' : 'none'}" v-if="this.isPopup" role="menu" id="logoLayer" class="logo__layer">
									<a role="menuitem" aria-label="Amway"></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>

		<div class="contents">
			<div class="contents__contents contents__contents--result">

				<!-- Step 1 알쏭달쏭 단백질 퀴즈 결과계산 -->
				<div class="contents__set">
					<p class="title title--white">당신의 단백질 지식 점수는?</p>
					<div class="contents__card result">
						<div class="result__point">
							<div class="result__row">
								<span v-if="this.myProteinQuizScore > 0">{{this.myProteinQuizScore}}점</span>
								<span v-else>0점</span>
							</div>
							<p class="desc desc--secondary desc--medium">{{this.proteinQuizScoreText}}</p>
						</div>
						<div class="button">
							<div class="button__row">
								<a style="cursor: pointer;" @click="answerResult" class="button__item button__item--tertiary">알쏭달쏭 단백질 퀴즈 정답 결과보기</a>
							</div>
						</div>
					</div>
				</div>
				<!-- Step 1 알쏭달쏭 단백질 퀴즈 결과계산 END -->

				<!-- Step 2 단백질 부족 자가진단 계산 -->
				<!-- 선택 항목 당 10점 -->
				<div class="contents__set">

					<!-- 1~3개 선택 10 ~ 30 점 -->
					<myproteinSelfLowScore v-if="this.proteinSelfScore >= 10 && this.proteinSelfScore <= 30" 
						:proteinSelfScore="this.proteinSelfScore"
						:proteinSelfCheckList = "this.userAnswer.self.Q9"
						/>
					<!-- 4 ~ 6개 40 ~ 60점 -->
					<myproteinSelfMiddleScore v-if="this.proteinSelfScore >= 40 && this.proteinSelfScore <= 60" 
						:proteinSelfScore="this.proteinSelfScore"
						:proteinSelfCheckList = "this.userAnswer.self.Q9" />

					<!-- 7~10개 100점 -->
					<myproteinSelfHighScore v-if="this.proteinSelfScore >= 70 && this.proteinSelfScore <= 100" 
						:proteinSelfScore="this.proteinSelfScore"
						:proteinSelfCheckList = "this.userAnswer.self.Q9" />
					
					<!--  Step 3 하루 권장 섭취량 체크 계산-->
					<div class="contents__card">
						<p class="desc desc--tertiary desc--bold">
							내 몸이 필요로 하는<br>
							<em>단백질 하루 권장 섭취량</em>
						</p>
						<div class="button button--inline">
							<div class="button__row">
								<a href="/myprotein-detail" class="button__item button__item--quaternary">
									주요 식품별 단백질 함량 알아보기
									<i></i>
								</a>
							</div>
						</div>
						<div class="measure">
							<div class="measure__measure">
								<p class="measure__number">{{this.proteinPurposeScore}}g</p>
								<div class="measure__bg" aria-hidden="true"></div>
							</div>
						</div>
					</div>
					<p class="contents__msg contents__msg--secondary">*출처:  Wu, Guoyao. “Dietary protein intake and human health.” Food & function 7.3 (2016): 1251-1265., Leidy, Heather J., et al. “The role of protein in weight loss and maintenance.” The American journal of clinical nutrition 101.6 (2015): 1320S-1329S., Am J Physiol Endocrinol Metab. 2015 Jan 1;308(1):E21-8.</p>
					<!-- Step 3 하루 권장 섭취량 체크 계산-->
				</div>

				<div class="contents__set">
					<p class="title">
						단백질,<br>
						왜 먹어야 할까요?
					</p>
					<div class="contents__card">
						<div class="protein-item">
							<ul class="protein-item__list">
								<li class="protein-item__item protein-item__item--01">
									<a href="/myprotein-info01" class="protein-item__row">
										<i></i>
										<p>우리 몸에서 수분 다음으로 많은 성분 &lsquo;단백질&rsquo;</p>
										<span class="protein-item__arrow" aria-hidden="true"></span>
									</a>
								</li>
								<li class="protein-item__item protein-item__item--02">
									<a href="/myprotein-info02" class="protein-item__row">
										<i></i>
										<p>우리 몸 속 많은 역할을 하는 &lsquo;단백질&rsquo;</p>
										<span class="protein-item__arrow" aria-hidden="true"></span>
									</a>
								</li>
								<li class="protein-item__item protein-item__item--03">
									<a href="/myprotein-info03" class="protein-item__row">
										<i></i>
										<p>나이가 들수록 감소하는 체내 &lsquo;단백질 양&rsquo;</p>
										<span class="protein-item__arrow" aria-hidden="true"></span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="contents__set">
					<p class="title">
						올바른<br>
						단백질 섭취 방법 4가지
					</p>
					<div class="card-swiper">
						<div class="card-swiper__swiper swiper-container">
							<div class="swiper-wrapper">
								<div class="card-swiper__slide card-swiper__slide--first swiper-slide" style="background-color: #DBDFE2;">
									<p class="card-swiper__header">첫번째</p>
									<div class="card-swiper__ico" aria-hidden="true"></div>
									<p class="desc">
										근육 증가를 위해서는 매일<br>
										<span class="line-highlight">체중 1kg당 1.5g 단백질 섭취</span>와 함께 주 3회 이상 근력 운동 수행을 필요로 합니다.
									</p>
									<p class="card-swiper__msg">*출처: Am J Physiol Endocrinol Metab. 2015 Jan 1;308(1):E21-8.</p>
								</div>
								<div class="card-swiper__slide card-swiper__slide--second swiper-slide">
									<p class="card-swiper__header">두번째</p>
									<div class="card-swiper__ico" aria-hidden="true"></div>
									<p class="desc">
										단백질은 <span class="line-highlight">3시간 이상</span>의
										간격을 두고 균등하게 섭취합니다.
									</p>
									<p class="card-swiper__msg">*출처:  Moore, Daniel R., et al. “Daytime pattern of post-exercise protein intake affects whole-body protein turnover in resistance-trained males.” Nutrition & metabolism 9.1 (2012): 1-5.</p>
								</div>
								<div class="card-swiper__slide card-swiper__slide--third swiper-slide" style="background-color: #00D060;">
									<p class="card-swiper__header">세번째</p>
									<div class="card-swiper__ico" aria-hidden="true"></div>
									<p class="desc">
										하루에 최소 세번 이상 특히<br>
										운동 후 <span class="line-highlight">45분 이내</span>의 골든타임을 지켜서 섭취합니다.
									</p>
									<p class="card-swiper__msg">*출처:  Ivy, J. L., & Ferguson-Stegall, L. M. (2013). Nutrient Timing. American Journal of Lifestyle Medicine, 8(4), 246-259.</p>
								</div>
								<div class="card-swiper__slide card-swiper__slide--fourth swiper-slide">
									<p class="card-swiper__header">네번째</p>
									<div class="card-swiper__ico" aria-hidden="true"></div>
									<p class="desc">
										단백질의 대사와 합성을<br>
										<span class="line-highlight">도와주는 비타민, 미네랄과 함께</span><br>
										섭취합니다.
									</p>
								</div>
							</div>
							<div class="swiper-pagination"></div>
							<div class="swiper-button-prev"></div>
							<div class="swiper-button-next"></div>
						</div>
					</div>
				</div>
				<div class="contents__set button">
					<div class="button__row">
						<a href="/myprotein" class="button__item button__item--secondary">
							<i></i>
							다시 시작하기
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Swiper from 'swiper';

import { mapState } from 'vuex'
import { MYPROTEIN } from '@/store/actions/myprotein'

import myproteinSelfLowScore from './component/myproteinSelfLowScore.vue'
import myproteinSelfMiddleScore from './component/myproteinSelfMiddleScore.vue'
import myproteinSelfHighScore from './component/myproteinSelfHighScore.vue'

export default {
    name : 'myprotein-result',
    data () {
        return {
			// LocalStorage Item
			userAnswer : JSON.parse(localStorage.getItem('userAnswer')),
			// 알쏭달쏭 단백질 퀴즈 정답 리스트
			quizAnswerList : {
				Q1 : 'X',
				Q2 : 'X',
				Q3 : 'O',
				Q4 : 'X',
				Q5 : ['1','3','4'],
				Q6 : '3',
				Q7 : '2',
				Q8 : '4'
			},
			correct : null , // 알쏭달쏭 퀴즈 정답 개수 체크
			myProteinQuizScore : null,     // 퀴즈 점수
			proteinQuizScoreText : null,   // 퀴즈 점수에 맞는 Text
			proteinSelfScore : null, 	   // 자가진단 점수
			proteinPurposeScore : null ,   // 단백질 섭취목적 계산
			isPopup : false
        }
    },
	computed : {
		...mapState(MYPROTEIN,{
			proteinQuiz: state => state.proteinQuiz,
			proteinSelfCheck: state => state.proteinSelfCheck,
			proteinPurpose: state => state.proteinPurpose
		})
  	},
	components : {
		// 10~30점
		myproteinSelfLowScore : myproteinSelfLowScore,
		// 40~60점
		myproteinSelfMiddleScore : myproteinSelfMiddleScore,
		// 70~100점
		myproteinSelfHighScore : myproteinSelfHighScore
	},

    mounted () {

		// Swiper 초기화
        this.initSwiper()

		// 1.알쏭달쏭 단백질 퀴즈
		//   문제 당 * 12.5 계산
		this.proteinQuizResult()
		// 2.단백질 자가진단
		//   선택 항목 당 +10 계산
		this.proteinSelfCheckResult()
		// 3. 단백질 섭취목적
		this.proteinPurposeResult()
		// 건강을 위해 필수 영양소인 단백질을 섭취하려고 해요 : 몸무게 x 1.2
		// 탄탄한 몸을 위해 체지방 조절을 하고 싶어요 : 몸무게 x 1.2
		// 근육 증가를 원해요 : 몸무게 x 1.5

    },
    methods : {
		// Step 1. 알쏭달쏭 단백질 퀴즈 
		proteinQuizResult () {
			// O X 계산
			for (let i in this.userAnswer.quiz) {
				if (this.userAnswer.quiz[i].includes(this.quizAnswerList[i])) {
					this.correct ++
					this.myProteinQuizScore += 12.5
				}
			}
			// Q5 중복선택 계산
			// 정답 : 1,3,4
			let cnt = null
			for (let j = 0 ; j < this.userAnswer.quiz.Q5.length ; j ++) {
				if(JSON.stringify(this.userAnswer.quiz.Q5[j]) === JSON.stringify(this.quizAnswerList.Q5[j]) ) {
					cnt += 1
					// Q5 정답결과가 일치 할 경우 +12.5 증가
					if (cnt === 3) {
						this.correct +=1
						this.myProteinQuizScore += 12.5
					}
				}else {
					// console.log("Q5 값이 다름!")
				}
			}
			
			// 정답결과에 따라 파이차트 및 문구 출력하기
			// 정답개수 0~2개    
			if(this.myProteinQuizScore <= 12.5 || this.myProteinQuizScore <= 25.0) {
				this.proteinQuizScoreText = '시작이 반 입니다!'
			// 3 ~ 4개
			}else if(this.myProteinQuizScore <= 37.5 || this.myProteinQuizScore <= 50.0) {
				this.proteinQuizScoreText = '조금만 더 노력해주세요!'
			// 5 ~ 6개
			}else if (this.myProteinQuizScore <= 62.5 || this.myProteinQuizScore <= 87.5) {
				this.proteinQuizScoreText = '거의 전문가 수준이네요!'
			}else {
			// 8개
				this.proteinQuizScoreText = '완벽해요!'
			}
		},

		proteinSelfCheckResult () {
			console.log("단백질 자가진단 : ", this.userAnswer.self.Q9.length)
			for (let i=0 ; i<this.userAnswer.self.Q9.length; i ++) {
				this.proteinSelfScore += 10
			}
		},

		// 단백질 섭취목적 계산.
		proteinPurposeResult () {
			let dailyProtein = 0
			switch(this.userAnswer.purp.Q10) {
				case 'Q10-1':
					// 건강을 위해 필수 영양소인 단백질을 섭취하려고 해요 : 몸무게 x 1.2
					dailyProtein = this.userAnswer.purp.userWeight * 1.2
					break;
				case 'Q10-2':
					// 탄탄한 몸을 위해 체지방 조절을 하고 싶어요 : 몸무게 x 1.2
					dailyProtein = this.userAnswer.purp.userWeight * 1.2
					break;
				case 'Q10-3':
					// 근육 증가를 원해요 : 몸무게 x 1.5
					dailyProtein = this.userAnswer.purp.userWeight * 1.5
					break;
			}
			this.proteinPurposeScore = dailyProtein.toFixed(1)
		},
		answerResult () {
			this.$router.push({
				name : 'myprotein-answer-result',
				params : { data : this.userAnswer.quiz}
			})
		},

		// 상단 위 팝업처리
		popup(){
			this.isPopup = !this.isPopup
		},

		initSwiper() {
            new Swiper ('.card-swiper__swiper',{
                autoplay: {
					delay: 5000
				},
				breakpoints: {
					1024: {
						cardsEffect: {
							perSlideOffset: 5,
							perSlideRotate: 4
						},
					}
				},
				// effect: 'cards',
				cardsEffect: {
					perSlideOffset: 10,
					perSlideRotate: 3
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets'
				},
				speed: 400
            })
        },
    }
}

</script>

<style>
@import "./assets/css/amway.css";
.rotate-down {
	transform: rotate(-270deg) !important
}
</style>


// WEBPACK FOOTER //
// src/views/myprotein-test/myproteinResult.vue